var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutputCircleFill0Wght400Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-79 294-265l42-42 114 113v-436h60v436l114-113 42 42L480-79ZM146-260q-32-49-49-105T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 59-17 115t-49 105l-44-42q25-41 37.5-85.5T820-480q0-142-99-241t-241-99q-142 0-241 99t-99 241q0 48 12.5 93t37.5 85l-44 42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputCircleFill0Wght400Grad0Opsz48);
export default __webpack_public_path__ + "static/media/output_circle_FILL0_wght400_GRAD0_opsz48.c0acb38aca7f06f61a5a7c9ddd7cd7e8.svg";
export { ForwardRef as ReactComponent };